import { InjectionToken } from "@angular/core";

export const POPUP_OVERLAY_CONTAINER_TOKEN = new InjectionToken<() => HTMLElement>(
    "Popup custom overlay container",
);
